const n = "md-editor", l = "md-editor-rt", d = "https://at.alicdn.com/t/c/font_2605852_prouiefeic.js", c = "https://at.alicdn.com/t/c/font_2605852_prouiefeic.css", e = "https://cdnjs.cloudflare.com/ajax/libs", h = `${e}/highlight.js/11.7.0/highlight.min.js`, g = {
  main: `${e}/prettier/2.8.0/standalone.js`,
  markdown: `${e}/prettier/2.8.0/parser-markdown.js`
}, m = {
  css: `${e}/cropperjs/1.5.13/cropper.min.css`,
  js: `${e}/cropperjs/1.5.13/cropper.min.js`
}, p = `${e}/screenfull.js/5.2.0/screenfull.min.js`, o = [
  "bold",
  "underline",
  "italic",
  "strikeThrough",
  "-",
  "title",
  "sub",
  "sup",
  "quote",
  "unorderedList",
  "orderedList",
  "task",
  "-",
  "codeRow",
  "code",
  "link",
  "image",
  "table",
  "mermaid",
  "katex",
  "-",
  "revoke",
  "next",
  "save",
  "=",
  "prettier",
  "pageFullscreen",
  "fullscreen",
  "preview",
  "htmlPreview",
  "catalog",
  "github"
], a = ["markdownTotal", "=", "scrollSwitch"], u = {
  "zh-CN": {
    toolbarTips: {
      bold: "加粗",
      underline: "下划线",
      italic: "斜体",
      strikeThrough: "删除线",
      title: "标题",
      sub: "下标",
      sup: "上标",
      quote: "引用",
      unorderedList: "无序列表",
      orderedList: "有序列表",
      task: "任务列表",
      codeRow: "行内代码",
      code: "块级代码",
      link: "链接",
      image: "图片",
      table: "表格",
      mermaid: "mermaid图",
      katex: "katex公式",
      revoke: "后退",
      next: "前进",
      save: "保存",
      prettier: "美化",
      pageFullscreen: "浏览器全屏",
      fullscreen: "屏幕全屏",
      preview: "预览",
      htmlPreview: "html代码预览",
      catalog: "目录",
      github: "源码地址"
    },
    titleItem: {
      h1: "一级标题",
      h2: "二级标题",
      h3: "三级标题",
      h4: "四级标题",
      h5: "五级标题",
      h6: "六级标题"
    },
    imgTitleItem: {
      link: "添加链接",
      upload: "上传图片",
      clip2upload: "裁剪上传"
    },
    linkModalTips: {
      linkTitle: "添加链接",
      imageTitle: "添加图片",
      descLabel: "链接描述：",
      descLabelPlaceHolder: "请输入描述...",
      urlLabel: "链接地址：",
      urlLabelPlaceHolder: "请输入链接...",
      buttonOK: "确定"
    },
    clipModalTips: {
      title: "裁剪图片上传",
      buttonUpload: "上传"
    },
    copyCode: {
      text: "复制代码",
      successTips: "已复制！",
      failTips: "复制失败！"
    },
    mermaid: {
      flow: "流程图",
      sequence: "时序图",
      gantt: "甘特图",
      class: "类图",
      state: "状态图",
      pie: "饼图",
      relationship: "关系图",
      journey: "旅程图"
    },
    katex: {
      inline: "行内公式",
      block: "块级公式"
    },
    footer: {
      markdownTotal: "字数",
      scrollAuto: "同步滚动"
    }
  },
  "en-US": {
    toolbarTips: {
      bold: "bold",
      underline: "underline",
      italic: "italic",
      strikeThrough: "strikeThrough",
      title: "title",
      sub: "subscript",
      sup: "superscript",
      quote: "quote",
      unorderedList: "unordered list",
      orderedList: "ordered list",
      task: "task list",
      codeRow: "inline code",
      code: "block-level code",
      link: "link",
      image: "image",
      table: "table",
      mermaid: "mermaid",
      katex: "formula",
      revoke: "revoke",
      next: "undo revoke",
      save: "save",
      prettier: "prettier",
      pageFullscreen: "fullscreen in page",
      fullscreen: "fullscreen",
      preview: "preview",
      htmlPreview: "html preview",
      catalog: "catalog",
      github: "source code"
    },
    titleItem: {
      h1: "Lv1 Heading",
      h2: "Lv2 Heading",
      h3: "Lv3 Heading",
      h4: "Lv4 Heading",
      h5: "Lv5 Heading",
      h6: "Lv6 Heading"
    },
    imgTitleItem: {
      link: "Add Img Link",
      upload: "Upload Img",
      clip2upload: "Clip Upload"
    },
    linkModalTips: {
      linkTitle: "Add Link",
      imageTitle: "Add Image",
      descLabel: "Desc:",
      descLabelPlaceHolder: "Enter a description...",
      urlLabel: "Link:",
      urlLabelPlaceHolder: "Enter a link...",
      buttonOK: "OK"
    },
    clipModalTips: {
      title: "Crop Image",
      buttonUpload: "Upload"
    },
    copyCode: {
      text: "Copy",
      successTips: "Copied!",
      failTips: "Copy failed!"
    },
    mermaid: {
      flow: "flow",
      sequence: "sequence",
      gantt: "gantt",
      class: "class",
      state: "state",
      pie: "pie",
      relationship: "relationship",
      journey: "journey"
    },
    katex: {
      inline: "inline",
      block: "block"
    },
    footer: {
      markdownTotal: "Word Count",
      scrollAuto: "Scroll Auto"
    }
  }
}, k = `${e}/mermaid/10.1.0/mermaid.esm.min.mjs`, f = {
  js: `${e}/KaTeX/0.16.3/katex.min.js`,
  css: `${e}/KaTeX/0.16.3/katex.min.css`
}, b = {
  a11y: {
    light: `${e}/highlight.js/11.7.0/styles/a11y-light.min.css`,
    dark: `${e}/highlight.js/11.7.0/styles/a11y-dark.min.css`
  },
  atom: {
    light: `${e}/highlight.js/11.7.0/styles/atom-one-light.min.css`,
    dark: `${e}/highlight.js/11.7.0/styles/atom-one-dark.min.css`
  },
  github: {
    light: `${e}/highlight.js/11.7.0/styles/github.min.css`,
    dark: `${e}/highlight.js/11.7.0/styles/github-dark.min.css`
  },
  gradient: {
    light: `${e}/highlight.js/11.7.0/styles/gradient-light.min.css`,
    dark: `${e}/highlight.js/11.7.0/styles/gradient-dark.min.css`
  },
  kimbie: {
    light: `${e}/highlight.js/11.7.0/styles/kimbie-light.min.css`,
    dark: `${e}/highlight.js/11.7.0/styles/kimbie-dark.min.css`
  },
  paraiso: {
    light: `${e}/highlight.js/11.7.0/styles/paraiso-light.min.css`,
    dark: `${e}/highlight.js/11.7.0/styles/paraiso-dark.min.css`
  },
  qtcreator: {
    light: `${e}/highlight.js/11.7.0/styles/qtcreator-light.min.css`,
    dark: `${e}/highlight.js/11.7.0/styles/qtcreator-dark.min.css`
  },
  stackoverflow: {
    light: `${e}/highlight.js/11.7.0/styles/stackoverflow-light.min.css`,
    dark: `${e}/highlight.js/11.7.0/styles/stackoverflow-dark.min.css`
  }
}, j = {
  modelValue: "",
  theme: "light",
  className: "",
  onChange: () => {
  },
  onSave: () => {
  },
  pageFullscreen: !1,
  preview: !0,
  htmlPreview: !1,
  language: "zh-CN",
  toolbars: o,
  toolbarsExclude: [],
  noPrettier: !1,
  onHtmlChanged: () => {
  },
  onGetCatalog: () => {
  },
  editorId: l,
  tabWidth: 2,
  showCodeRowNumber: !1,
  previewTheme: "default",
  mdHeadingId: (t) => t,
  style: {},
  tableShape: [6, 4],
  noMermaid: !1,
  sanitize: (t) => t,
  placeholder: "",
  noKatex: !1,
  defToolbars: [],
  onError: () => {
  },
  codeTheme: "atom",
  footers: a,
  scrollAuto: !0,
  defFooters: [],
  noIconfont: !1,
  formatCopiedText: (t) => t,
  noUploadImg: !1,
  codeStyleReverse: !0,
  codeStyleReverseList: ["default", "mk-cute"],
  autoFocus: !1,
  disabled: !1,
  readOnly: !1,
  autoDetectCode: !1,
  noHighlight: !1,
  noImgZoomIn: !1,
  inputBoxWitdh: "50%"
}, r = {
  editorExtensions: {},
  editorConfig: {},
  codeMirrorExtensions: (t, s) => s,
  markdownItConfig: () => {
  },
  markdownItPlugins: (t) => t,
  iconfontType: "svg"
}, v = (t) => {
  if (t)
    for (const s in t) {
      const i = t[s];
      i && (r[s] = i);
    }
}, y = 170;
export {
  y as M,
  d as a,
  o as b,
  v as c,
  a as d,
  j as e,
  r as f,
  g,
  m as h,
  c as i,
  b as j,
  h as k,
  p as l,
  k as m,
  f as n,
  n as p,
  u as s
};
